import { IMessengerMessage } from '@locumsnest/components/src/lib/interfaces/message';
import { IMessengerUser } from '@locumsnest/user/src/lib/+state/entity/interfaces';

export interface IMessagingUiState {
  readonly showNewMessage: boolean;
  readonly showColleagueList: boolean;
  readonly selectedAction: ISelectedActionEnum;
  readonly showSectionCategories: boolean;
}

export interface IMessageListItem {
  readonly id: number;
  readonly receivers: IMessengerUser[];
  readonly messages: IMessengerMessage[];
  readonly createdAt: Date;
  readonly updatedAt?: Date;
}

export enum ISelectedActionEnum {
  NONE,
  FAQ,
  SUPPORT,
  MESSAGE,
}
